var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,23.5c-13.509,0-24.5,10.991-24.5,24.5c0,13.51,10.991,24.5,24.5,24.5c13.51,0,24.5-10.99,24.5-24.5 C72.5,34.491,61.51,23.5,48,23.5z M48,68.5c-11.304,0-20.5-9.196-20.5-20.5S36.696,27.5,48,27.5S68.5,36.696,68.5,48 S59.304,68.5,48,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,41.663c-3.494,0-6.337,2.843-6.337,6.337s2.843,6.337,6.337,6.337s6.337-2.843,6.337-6.337S51.494,41.663,48,41.663z  M48,50.337c-1.289,0-2.337-1.048-2.337-2.337c0-1.289,1.048-2.337,2.337-2.337c1.289,0,2.337,1.048,2.337,2.337 C50.337,49.289,49.289,50.337,48,50.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.856,33.772c0.125,0,0.253-0.012,0.38-0.037c0.902-0.174,1.832-0.262,2.763-0.262c1.104,0,2-0.896,2-2s-0.896-2-2-2 c-1.184,0-2.368,0.112-3.519,0.334c-1.085,0.208-1.795,1.257-1.586,2.342C43.079,33.107,43.917,33.772,44.856,33.772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.549,32.701C32.493,36.161,29.474,41.88,29.474,48c0,1.104,0.896,2,2,2s2-0.896,2-2c0-4.799,2.368-9.284,6.334-11.998 c0.912-0.624,1.145-1.868,0.521-2.78C39.706,32.311,38.461,32.079,37.549,32.701z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisc);
export default __webpack_public_path__ + "static/media/disc.69f3251ee058dd135f501306208951bb.svg";
export { ForwardRef as ReactComponent };